import React from 'react';
import "./PrestadoresList.scss";
import { Card, LoadButton, TitleSecondary } from '..';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const PrestadoresList = () => {
    return (
        <>
            <div className="prestadores-list">
                <Card
                    image="https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Fernando Torres"
                    occupation="Electricista"
                    price="3000"
                />
                <Card
                    image="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Raul Fernandez"
                    occupation="Pintor"
                    price="5000"
                />
                <Card
                    image="https://images.pexels.com/photos/1844547/pexels-photo-1844547.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Hector Herrera"
                    occupation="Herrero"
                    price="2000"
                />
                <Card
                    image="https://images.pexels.com/photos/1139743/pexels-photo-1139743.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Lucas Fernandez"
                    occupation="Cerrajero"
                    price="7000"
                />
                <Card
                    image="https://images.pexels.com/photos/2287252/pexels-photo-2287252.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Rodrigo Peña"
                    occupation="Pintor"
                    price="3000"
                />
                <Card
                    image="https://images.pexels.com/photos/2117283/pexels-photo-2117283.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Diego Perez"
                    occupation="Plomero"
                    price="2500"
                />
                <Card
                    image="https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Fernando Torres"
                    occupation="Electricista"
                    price="3000"
                />
                <Card
                    image="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Raul Fernandez"
                    occupation="Pintor"
                    price="5000"
                />
                <Card
                    image="https://images.pexels.com/photos/1844547/pexels-photo-1844547.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    name="Hector Herrera"
                    occupation="Herrero"
                    price="2000"
                />
            </div>
            <div className="pagination">
                <Stack spacing={2}>
                    <Pagination count={10} />
                </Stack>
            </div>
        </>
    )
}

export default PrestadoresList;
